import React from "react";
import { Github, FileText } from "lucide-react";
import { GradientText } from "./ui/shadcn-io/gradient-text";
import logo from "../assets/yLogo.png";

export default function Navbar() {
  return (
    <nav className="fixed top-0 left-0 z-50 w-full bg-[#1e293b] border-b-2 border-gray-100 shadow-sm backdrop-blur-md">
      <div className="relative flex items-center justify-between px-8 py-3 mx-auto sm:px-16 sm:py-12 lg:px-6 lg:py-3 max-w-7xl">

        <div className="flex items-center gap-4 sm:gap-10">
          <a
            href="https://github.com/yahyamomtaz"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 text-gray-200 transition-colors hover:text-gray-400"
          >
            <Github className="w-6 h-6 sm:w-8 sm:h-8 lg:w-5 lg:h-5" />
            <span className="hidden text-sm font-medium sm:hidden lg:inline">GitHub</span>
          </a>

          <a
            href="https://www.mdpi.com/2313-433X/11/5/136"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 text-gray-200 transition-colors hover:text-gray-400"
          >
            <FileText className="w-6 h-6 sm:w-8 sm:h-8 lg:w-5 lg:h-5" />
            <span className="hidden text-sm font-medium sm:hidden lg:inline">Publication</span>
          </a>
        </div>

        <div className="absolute transform -translate-x-1/2 left-1/2">
          <GradientText
            text="Bleed-Through Cleaner"
            gradient="linear-gradient(90deg, #3b82f6 0%, #a855f7 20%, #ec4899 50%, #a855f7 80%, #3b82f6 100%)"
            className="text-lg font-semibold text-center lg:text-xl sm:text-4xl whitespace-nowrap"
          />
        </div>

        <a
          href="https://yayamomt.tech/"
          target="_blank"
          className="flex items-center ml-auto"
        >
          <img
            src={logo}
            alt="Logo"
            className="object-contain w-10 h-10 sm:w-16 sm:h-16 lg:w-10 lg:h-10"
          />
        </a>
      </div>
    </nav>
  );
}
